import './chart.style.less'

import { cloneDeep, debounce } from 'lodash'

import { Doughnut } from 'react-chartjs-2'
import GaugeTargetChart from './GaugeTarget'
import MainWrapper from './MainWrapper'
import { useState } from 'react'

interface props {
  title: string
  sign?: string
  showLegend?: boolean
  data?: any
  id: string
  target?: boolean
  periods?: string[]
  onPeriodChange?: (period: string) => any
}

function GaugeChart(props: props) {
  const {
    data,
    showLegend = true,
    title,
    sign = '',
    target = false,
    id,
    periods = [],
    onPeriodChange = () => {},
  } = props

  const options = {
    maintainAspectRatio: false,
    rotation: 270, // start angle in degrees
    circumference: 180, // sweep angle in degrees
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: {
        left: 100,
        right: 100,
      },
    },
    cutout: 120,
  }

  const [targetData, setTargetData] = useState<any>({
    ...cloneDeep(data),
    labels: ['', '', ''],
    datasets: [
      {
        label: 'labels',
        data: [0, 0, 0],
        backgroundColor: [
          'rgba(0, 0, 0, 0)',
          'rgba(173, 173, 173, 1)',
          'rgba(0, 0, 0, 0)',
        ],
      },
    ],
  })

  const onTarget = (value) => {
    if (!value) return

    let _data = []
    if (value > 100 || value <= 0 || !value || isNaN(value)) _data = [0, 0, 0]
    else _data = [value - 1, 1, 100 - value]

    setTargetData({
      ...targetData,
      datasets: ['', '', '', '', '', '', '', '', ''].map((item, i) => {
        if (i % 2 === 1)
          return {
            weight: 1,
          }
        return {
          label: '',
          data: _data,
          backgroundColor: [
            'rgba(0, 0, 0, 0)',
            'rgba(173, 173, 173, 1)',
            'rgba(0, 0, 0, 0)',
          ],
        }
      }),
    })
  }

  return (
    <MainWrapper
      id={id}
      title={title}
      isTarget={target}
      onTarget={debounce(onTarget, 500)}
      onPeriodChange={onPeriodChange}
      periods={periods}
    >
      <GaugeTargetChart options={options} data={targetData} />
      <Doughnut redraw data={data} options={options} />
    </MainWrapper>
  )
}
export default GaugeChart
